// A fully transparent colour (8-digit hex with alpha 00) prints nothing, like 'none'.
const hasInk = (colour: string | undefined) =>
  Boolean(colour && colour !== 'none' && colour !== 'transparent' && !/^#[0-9a-f]{6}00$/i.test(colour));

export default hasInk;
